<ds-item-detail-preview [item]="item"
                        [object]="object"
                        [badgeContext]="badgeContext"
                        [showLabel]="showLabel"
                        [showMetrics]="showMetrics"></ds-item-detail-preview>

<ds-workflowitem-actions [object]="dso"></ds-workflowitem-actions>

